<template>
  <div>
    <div class="drop-zone-container uk-flex uk-flex-middle uk-flex-center">
      <div class="drop-zone uk-inline">
        <div class="uk-flex uk-flex-center drop-file-style">
          <span>{{$t('dropZone.dropAFile')}}</span>
        </div>
        <div class="uk-flex uk-flex-center or-style">
          <span>- {{$t('general.or')}} -</span>
        </div>
        <div class="uk-flex uk-flex-center browse-style">
          <input ref="fileInput" class="uk-hidden" type="file" id="file-upload" accept=".notebook" @click="onClick" @change="onChange($event.target.files)">
          <label class="browse-file-style add-pointer" for="file-upload">{{$t('dropZone.browseToAFile')}}</label>
        </div>
        <div class="uk-flex uk-flex-center notebook-style">
          <span><img class="notebook-icon" :src="notebookIcon"/>{{$t('dropZone.notebookOnly')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import iconUtil from '../../../../utils/icon-util'
  import * as misc from '../../../../enums/misc'

  export default {
    name: 'upload',
    data() {
      return {
        notebookIcon: iconUtil.resolve(misc.NOTEBOOK_ICON)
      }
    },
    methods: {
      onChange (files) {
        this.$emit('resource-selected', files[0])
      },
      onClick() {
        // clears the input everytime incase user wants to add the same resource
        this.$refs.fileInput.value = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../../styles/colours';


  .browse-style {
    margin-top: 32px;
    font-size: 25px;
  }

  .browse-file-style {
    color: $content-link-blue;
    font-weight: bold;
    &:hover {
      text-decoration: underline;
    }
  }

  .drop-file-style {
    margin-top: 100px;
    font-size: 30px;
    font-weight: bold;
  }

  .drop-zone {
    width: 90%;
    height: 90%;
    border: 4px dashed lightgray;
    border-radius: 4px;
  }

  .drop-zone-container {
    max-width: 600px;
    height: 464px;
    background-color: white;
    border-radius: 8px;
  }

  .or-style {
    margin-top: 32px;
    font-size: 25px;
  }

  .top-padding {
    padding-top: 80px;
  }

  .notebook-style {
    margin-top: 62px
  }

  .notebook-icon {
    margin-right: 11px;
  }


</style>
